import {sampleAccountsData} from "../data/sample/SampleAccountsData";

export const USER_SIGNED_IN = 'USER_SIGNED_IN';
export const USER_SIGNED_OUT = 'USER_SIGNED_OUT';
export const USER_IS_LOADING = 'USER_IS_LOADING';
export const ACCOUNTS_ARE_LOADING = "ACCOUNTS_ARE_LOADING";
export const ACCOUNTS_FETCH_ERROR = "ACCOUNTS_FETCH_ERROR";
export const ACCOUNTS_HAVE_LOADED = "ACCOUNTS_HAVE_LOADED";
export const USER_SUBMITTED_FEEDBACK = "USER_SUBMITTED_FEEDBACK";
export const USER_SUBMITTED_SECURITY = "USER_SUBMITTED_SECURITY";
export const SECURITY_PROFILE_LOADED = "SECURITY_PROFILE_LOADED";

/* The below are simple action objects */
export const userSignedInAction = (user) => {
    return { type: USER_SIGNED_IN, user: user }
};

export const userSignedOutAction = () => {
    return { type: USER_SIGNED_OUT }
};

export const userIsLoadingAction = (booleanValue) => {
    return { type: USER_IS_LOADING, val: booleanValue }
};

export const accountsLoadingAction = (booleanValue) => {
    return { type: ACCOUNTS_ARE_LOADING, val: booleanValue }
};

export const accountsErrorAction = (err) => {
    return { type: ACCOUNTS_FETCH_ERROR, err }
};

export const accountsLoadedAction = (accounts) => {
    return { type: ACCOUNTS_HAVE_LOADED, accounts }
};

/* I want to include trivial things like this, because I'm going to
   promote all these events to a remote react logging service. If user
   feedback submission failed, I'd like to know that also.
 */
export const userSubmittedFeedbackAction = (recordedMsg) => {
    return { type: USER_SUBMITTED_FEEDBACK, recordedMsg }
};

export const userSubmittedSecurityConfigAction = (securityProfile) => {
    return { type: USER_SUBMITTED_SECURITY, securityProfile: securityProfile }
};

export const securityProfileHasLoadedAction = (userSecurityProfile) => {
    return { type: SECURITY_PROFILE_LOADED, securityProfile: userSecurityProfile }
};
/* ================================================================================ */


